import createIcon from '../../createIcon';

/**
 * @component @name HdrOn
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjEgMTEuNVYxMC41QzIxIDkuNyAyMC4zIDkgMTkuNSA5SDE2VjE1SDE3LjVWMTNIMTguNkwxOS41IDE1SDIxTDIwLjEgMTIuOUMyMC42IDEyLjYgMjEgMTIuMSAyMSAxMS41Wk0xOS41IDExLjVIMTcuNVYxMC41SDE5LjVWMTEuNVpNNi41IDExSDQuNVY5SDNWMTVINC41VjEyLjVINi41VjE1SDhWOUg2LjVWMTFaTTEzIDlIOS41VjE1SDEzQzEzLjggMTUgMTQuNSAxNC4zIDE0LjUgMTMuNVYxMC41QzE0LjUgOS43IDEzLjggOSAxMyA5Wk0xMyAxMy41SDExVjEwLjVIMTNWMTMuNVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const HdrOn = createIcon('HdrOn', [
  [
    'path',
    {
      d: 'M21 11.5V10.5C21 9.7 20.3 9 19.5 9H16V15H17.5V13H18.6L19.5 15H21L20.1 12.9C20.6 12.6 21 12.1 21 11.5ZM19.5 11.5H17.5V10.5H19.5V11.5ZM6.5 11H4.5V9H3V15H4.5V12.5H6.5V15H8V9H6.5V11ZM13 9H9.5V15H13C13.8 15 14.5 14.3 14.5 13.5V10.5C14.5 9.7 13.8 9 13 9ZM13 13.5H11V10.5H13V13.5Z',
      key: '1wbxfo',
    },
  ],
]);

export default HdrOn;
